export const Types = {
  SELECTED_HOMEPAGE_LAYOUT: 'SELECTED_HOMEPAGE_LAYOUT'
};

export const selectedHomepageLayoutAction = (layoutId) => ({
  layoutId: layoutId,
  type: Types.SELECTED_HOMEPAGE_LAYOUT
});



// WEBPACK FOOTER //
// ./public/pages/EditHomepageLayoutsPage/actions.js